export enum ETypOsoby {
    OPRAVNENA = 'OPR',
    POVERENA = 'POV'
}
